import { ImportWizardDataRaw } from '../../typings/importWizard';

export const UPDATE_IMPORT_WIZARD_DATA = 'UPDATE_IMPORT_WIZARD_DATA';
export type UPDATE_IMPORT_WIZARD_DATA = typeof UPDATE_IMPORT_WIZARD_DATA;

export interface UpdateImportWizardData {
    type: UPDATE_IMPORT_WIZARD_DATA;
    data: ImportWizardDataRaw;
}

export function updateImportWizardDataAction(data: ImportWizardDataRaw): UpdateImportWizardData {
    return {
        type: UPDATE_IMPORT_WIZARD_DATA,
        data
    };
}
